<template>
  <div>
    <table
      v-if="component.options.vertical_labels !== true"
      style="width: 100%"
      class="field-group-item-list"
    >
      <tr
        v-for="[field, index] in fields"
        :key="index"
        :style="getStyleForField(field, screenIsMobile)"
        class="field-group-item"
        :class="{required:(field.options && field.options.rules && field.options.rules.split('|').includes('required'))}"
      >
        <!-- eslint-disable vue/no-v-html -->
        <td
          v-if="component.options.no_labels !== true"
          :style="{
            paddingTop: '5px',
            textAlign: 'right',
            verticalAlign: 'top',
            width: '1px',
            whiteSpace: 'nowrap',
            paddingRight: screenIsMobile ? '0' : '16px'
          }"
          class="field-group-label"
          v-html="getFieldLabel(field)"
        />
        <td style="padding: 0">
          <a-row
            v-if="getSubfieldsForDisplay(field).length > 0"
            class="ant-row-flex"
            :gutter="[10,0]"
          >
            <a-col
              v-for="(subfield, key) in getSubfieldsForDisplay(field)"
              :key="key"
              :span="subfield.options.span"
              :flex="subfield?.options?.flex"
              style="display: flex;"
            >
              <div
                v-if="component.options.show_combined_fields_label"
                class="subfield_label"
                v-html="getFieldLabel(subfield , true)"
              />
              <FieldContainer
                ref="fieldContainer"
                v-model="resource[subfield.identifier]"
                :field="subfield"
                :module="module"
                :resource="resource"
                :root-field-tree="fieldTree"
                :translation-prefix="translationPrefix"
                :layout="layout"
                :mode="mode"
                :context="context"
                style="width: 100%; align-self: center;"
                @event="fieldEvent"
                @tree="setFieldTree(subfield, $event)"
              />
            </a-col>
          </a-row>
          <FieldContainer
            v-else
            ref="fieldContainer"
            v-model="resource[field.identifier]"
            :field="field"
            :module="module"
            :resource="resource"
            :root-field-tree="fieldTree"
            :translation-prefix="translationPrefix"
            :layout="layout"
            :mode="options.mode ? options.mode : mode"
            :context="context"
            @event="fieldEvent"
            @tree="setFieldTree(field, $event)"
          />
        </td>
      </tr>
    </table>
    <div
      v-for="[field, index] in fields"
      v-else
      :key="index"
      :style="getStyleForField(field, screenIsMobile)"
      class="field-group-item-list"
    >
      <!-- eslint-disable vue/no-v-html -->
      <div
        v-if="component.options.no_labels !== true && (component.options.show_combined_fields_label || getSubfieldsForDisplay(field).length == 0)"
        class="field-group-label"
        v-html="getFieldLabel(field)"
      />
      <div
        style="overflow-scrolling: touch"
        class="field-group-item"
      >
        <a-row
          v-if="getSubfieldsForDisplay(field).length > 0"
          class="ant-row-flex"
          :gutter="[10,0]"
          :type="flex"
        >
          <a-col
            v-for="(subfield, key) in getSubfieldsForDisplay(field)"
            :key="key"
            :span="subfield.options.span"
            :flex="subfield?.options?.flex"
          >
            <div
              :class="{'subfield_label': component.options.show_combined_fields_label}"
              v-html="getFieldLabel(subfield , true)"
            />
            <FieldContainer
              ref="fieldContainer"
              v-model="resource[subfield.identifier]"
              :field="subfield"
              :module="module"
              :resource="resource"
              :root-field-tree="fieldTree"
              :translation-prefix="translationPrefix"
              :layout="layout"
              :mode="mode"
              :context="context"
              @event="fieldEvent"
              @tree="setFieldTree(subfield, $event)"
            />
          </a-col>
        </a-row>
        <FieldContainer
          v-else
          ref="fieldContainer"
          v-model="resource[field.identifier]"
          :field="field"
          :module="module"
          :resource="resource"
          :root-field-tree="fieldTree"
          :translation-prefix="translationPrefix"
          :layout="layout"
          :mode="mode"
          :context="context"
          @event="fieldEvent"
          @tree="setFieldTree(field, $event)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import FieldContainer from '@/components/FieldContainer'
import LayoutComponentFieldGroup from '@/components/layout-components/LayoutComponentFieldGroup'
import Fields from '@/components/fields'

export default {
  name: 'LayoutComponentFieldGroupInputContent',
  components: { FieldContainer },
  extends: LayoutComponentFieldGroup,
  mixins: [
    Fields,
  ],
  methods: {
    getFieldLabel (field, sub = false) {
      const hasSubField = this.getSubfieldsForDisplay(field).length > 0
      if (field.identifier === undefined) {
        // in case of multiple fields take label of the first field
        if (hasSubField) { // Check if all subfields are hidden from frontend. if so, set field to null so it won't get a label
          field = field.getSubfields()[0]
        } else {
          field = null
        }
      }

      let labelText = ''
      if (field !== null) {
        labelText = this.tr(`${this.translationPrefix}.fields.${field.identifier}`, true)
        if (this.component.options.show_combined_fields_label && !sub && hasSubField) {
          labelText = this.tr(`${this.translationPrefix}.fields.combined_${field.identifier}`, true)
        }
        /* Append a * to the field Name if the field is required and the mark_required_fields option is true in the FieldGroup */
        if (this.component.options.mark_required_fields && field.options.rules === 'required') {
          labelText += '<span class="required-marker"><b> *</b></span>'
        }
        return labelText
      }
    },
  },
}
</script>
<style scoped>
  .subfield_label {
    color: rgba(0, 0, 0, 0.65);
    font-size:12px
  }
</style>
